import React, { ReactElement } from "react";
import { NavLink as RouterLink } from "react-router-dom";
import { Box, Button, ListItem } from "@mui/material";

// active: {
//   color: theme.palette.primary.main,
//   borderRight: `solid 4px ${theme.palette.primary.main}`,
//   "& $title": {
//     fontWeight: theme.typography.fontWeightMedium,
//   },
//   "& $icon": {
//     color: theme.palette.primary.main,
//   },
// },

interface Props {
  path: string;
  title: string;
  key?: string;
  icon?: ReactElement;
  rest?: any[];
}

const NavItem = ({ path, icon, title, ...rest }: Props): JSX.Element => {
  const isExternal = path.includes("http");
  return (
    <ListItem
      disableGutters
      {...rest}
      sx={{
        display: "flex",
        paddingTop: 0,
        paddingBottom: 0,
        marginBottom: 1,
      }}
    >
      <Button
        // activeClassName={classes.active}
        // className={classes.button}
        sx={{
          color: "text.primary",
          fontWeight: "fontWeightRegular",
          // fontSize: "14px",
          justifyContent: "flex-start",
          letterSpacing: 0,
          padding: "3px 0 2px 18px",
          textTransform: "none",
          width: "100%",
          borderRadius: 0,
          "&:hover": {
            color: "text.primary",
            backgroundColor: "rgba(111, 121, 212, 0.08)",
          },
          "&.active": {
            fontWeight: "fontWeightBold",
            backgroundColor: "rgba(111, 121, 212, 0.08)",
          },
          "&.active>.icon": {
            opacity: "1",
          },
        }}
        component={isExternal ? "a" : RouterLink}
        to={path}
        onClick={() => {
          isExternal && (window.location.href = path);
        }}
        disableRipple={true}
      >
        <Box
          component="span"
          sx={{
            margin: "8px 20px 0 0",
            opacity: "0.5",
          }}
          className="icon"
        >
          {icon}
        </Box>
        <Box
          component="span"
          // className={classes.title}
          sx={{
            marginRight: "auto",
            fontSize: 14,
          }}
        >
          {title}
        </Box>
      </Button>
    </ListItem>
  );
};

export default NavItem;
